const n = ({ name: i, url: f, document: t } = {}, e) => {
  if (i)
    return i;
  if (f)
    return f;
  if (t != null && t.info) {
    const r = t.info;
    if (r.title)
      return r.title;
  }
  return "default";
};
export {
  n as getDocumentName
};
